import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import FormTextField from 'src/components/form-elements/form-text-field.component';
import DoneButton from 'src/components/buttons/done-button.component';
import FleetMultiselect from './fleet-multiselect.component';

const useStyles = makeStyles((theme) => ({
    presentation: {
        height: theme.spacing(60)
    },
    cardStyle: {
        "&.MuiCard-root": {
            overflow: 'hidden',
            height: '100%',
            position: 'relative'
        }
    },
    cardActionStyle: {
        "&.MuiCardActions-root": {
            display: 'flex',
            padding: '8px',
            alignItems: 'center',
            justifyContent: 'flex-end',
            position: 'absolute',
            bottom: 0,
            right: 0
        }
    }
}));

const OrganizationAddEdit = ({ orgId, organization, editMode, onChange, handleClose, handleDone }) => {

    const handleChange = (event) => {
        onChange(event);
    };

    const classes = useStyles();

    return (
        <div role="presentation" className={classes.presentation}>
            <Card classes={{ root: classes.cardStyle }}>
                <CardHeader title={editMode ? "Edit Organization" : "New Organization"} />
                <Divider />
                <CardContent>
                    <FormTextField name="Organization name" labelText="Organization name" value={organization.name}
                        onChange={handleChange} disabled={false} ></FormTextField>
                    <FleetMultiselect orgId={orgId} onChange={handleChange} editMode={editMode} organization={organization} />

                </CardContent>
                <CardActions classes={{ root: classes.cardActionStyle }} >
                    <Button variant="contained" onClick={handleClose} color="default">
                        <Typography className={classes.cardFont} component="div">
                            Cancel
                        </Typography>
                    </Button>
                    <DoneButton handleDone={handleDone} placeholder='Done'></DoneButton>
                </CardActions>
            </Card>
        </div>
    );
}

export default OrganizationAddEdit;